import AntdAvatar from 'components/Avatar'
import Button from 'components/Button'
import Flex from 'components/Flex'
import EllipseDot from 'components/icons/EllipseDot'
import {
  CommentDiv,
  CommonFlex,
  ContentDiv,
  DetailsDiv,
  DetailsNameDiv,
  HeaderFlex,
  InterviewFlex,
  InterviewInfo,
  InterviewTime,
  InterviewerDiv,
  LeftFlex,
  NameDiv,
  NameInfoDiv,
  Padding,
  RightFlex,
  UploadFlex,
} from 'modules/Drives/ViewDriveRole/IndividualDriveTable/ViewCandidateInfoDrawer/InterviewDetails/CollapseText/style'
import { RejectRequest } from 'modules/Roles/actions'
import {
  getNotificationCatalogues,
  sendInAppNotification,
  sendNotificationEmail,
  sendNotificationWhatsapp,
} from 'modules/Users/actions'
import moment from 'moment'
import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { permittedEventCruds } from 'utils/permissionsValidation'
import CreateSlots from '../../../CreateSlotDrawer/index'
const CollapseText = ({
  interviewRoundInfo,
  interviwerDeatils,
  interViewerList,
  rolesMetrics,
  createInterview,
  driveId,
  roleId,
  driveInterViewerList,
  addCorporateBranch,
  getDriveInterviewerList,
  driveData,
  getCandidateList,
  candidateDeatils,
  getRoleMetrics,
  getInterViewLocation,
  interViewData,
  getListOfCountries,
  getListOfStates,
  getListOfCities,
  listOfCountries,
  listOfStates,
  listOfCities,
  candidateInfoData,
  setCandidateInfoData,
  corporateLocationsList,
  getCorporateLocationsList,
  groupList,
  getGroupDiscussionList,
  UpdateScheudle,
  ids,
  roundName,
  setNotification,
  setCandidateInfo,
  reasonItem,
  getDriveRoleCandidatesList,
}) => {
  const dispatch = new useDispatch()
  const corpData = useSelector(state => state?.auth?.corporateData)
  const permission = useSelector(state => state?.auth?.permissions)
  const [createSlotDrawer, setCreateSlotDrawer] = useState(false)
  const [interViewSchedulerData, setInterViewSchedulerData] = useState({})
  const [interViewUpdaterData, setInterViewUpdaterData] = useState({})
  const [interViewer, setInterViewer] = useState([])
  let [searchParams, setSearchParams] = useSearchParams()
  const stage = searchParams.get('stage')

  const [selectedRound, setSelectedRound] = useState(stage || 'all_candidates')
  const [selectedRoundType, setSelectedRoundType] = useState(interviewRoundInfo)
  const [selectedCandidate, setSelectedCandidate] = useState([])
  const [selectedCandidateId, setSelectedCandidateId] = useState([])
  const [rejectEmail, setRejectEmail] = useState(null)
  const permittedEvents = permittedEventCruds(
    permission,
    'Evaluation Process - Fresher'
  )
  const Schedule =
    permittedEvents?.find(item => item.events?.eventName === 'VIEW')?.events ||
    ''
  useEffect(() => {
    ;(async () => {
      if (Schedule?.id) {
        let responce = await dispatch(getNotificationCatalogues(Schedule?.id))

        const filteredArray2 = responce?.CatalogueData?.filter(
          item =>
            item.eventNotificationTemplate &&
            item.eventNotificationTemplate.templateName ===
              'Regarding Interview Rescheduling Request' &&
            item.eventNotificationTemplate.eventNotificationType &&
            item.eventNotificationTemplate.eventNotificationType.name ===
              'E-Mail'
        )

        if (filteredArray2?.length > 0) {
          setRejectEmail(filteredArray2[0].eventNotificationTemplate)
        }
      }
    })()

    return () => {}
  }, [Schedule])

  const getInterViewerDeatils = id => {
    const schedulerData = interviwerDeatils?.filter(data => {
      if (data?._id === id) {
        return data
      }
    })[0]
    return schedulerData
  }

  const getInterviwer = panelList => {
    let panelListId = panelList?.map(data => data?.id)

    const schedulerData = interviwerDeatils?.filter(data => {
      if (panelListId.includes(data?._id)) {
        return data
      }
    })
    return panelListId?.length > 0 && panelListId[0] ? schedulerData : 'NA'
  }

  useEffect(() => {
    setInterViewSchedulerData(
      getInterViewerDeatils(interviewRoundInfo?.interviewScheduler)
    )
    setInterViewUpdaterData(
      getInterViewerDeatils(interviewRoundInfo?.interviewUpdater)
    )
    setInterViewer(getInterviwer(interviewRoundInfo?.panel))
  }, [interviewRoundInfo, interviwerDeatils])

  const onRejectButton = () => {
    setCreateSlotDrawer(true)
  }

  const rejectData = async () => {
    let payload = { candidateStatus: 'PENDING' }
    const result = await dispatch(
      RejectRequest(
        ids?.parameters?.driveId,
        ids?.parameters?.roleId,
        ids?.parameters?.studentId,
        payload
      )
    )
    if (result?.status >= 200 && result?.status <= 300) {
      let InAppObj = {
        notification: {
          students: [
            {
              ids: [ids?.parameters?.studentId],
              userIds: [],
              roles: ['Student'],
              issuer: 'corporate',
              createFor: 'student',
              inApp: true,
              body: `Your interview reschedule request for the  ${rolesMetrics[0]?.roleName} at ${corpData?.name}  has been declined due to scheduling constraints.`,
              tag: 'Interview',
            },
          ],
        },
      }

      const template = rejectEmail?.templateText
        ?.replace('{companyName}', corpData?.name)
        ?.replace('{roleName}', rolesMetrics[0]?.roleName)

      dispatch(sendInAppNotification(InAppObj))
      let emailObj = {
        to: candidateInfoData?.student?.studentPersonalProfile?.primaryEmail,
        subject: rejectEmail?.subject,
        htmlBody: template,
      }
      dispatch(sendNotificationEmail(emailObj))

      let whatsapp = {
        to: candidateInfoData?.student?.studentPersonalProfile?.phoneNumber,
        templateName: 'drive_reject_request',
        components: [
          {
            type: 'HEADER',
            parameters: [
              {
                type: 'IMAGE',
                image: {
                  link: 'https://drive.google.com/uc?export=view&id=1do69IcSSUj3P6gX202Af8YUF6eCUv5XH',
                },
              },
            ],
          },
          {
            type: 'BODY',
            index: 0,
            sub_type: 'CATALOG',
            parameters: [
              {
                type: 'TEXT',
                text: candidateInfoData?.student?.firstName,
              },
              {
                type: 'TEXT',
                text: rolesMetrics[0]?.roleName,
              },
              {
                type: 'TEXT',
                text: corpData?.name,
              },
            ],
          },
        ],
      }
      dispatch(sendNotificationWhatsapp(whatsapp))
      setCandidateInfo(false)
    }
  }

  const getDate = () => {
    return interviewRoundInfo?.date ? (
      <Flex>
        {moment(interviewRoundInfo?.date[0]).format('DD/MM/YYYY') ===
        moment(interviewRoundInfo?.date[1]).format('DD/MM/YYYY') ? (
          <Fragment>
            {interviewRoundInfo?.date &&
              moment(interviewRoundInfo?.date[0]).format('DD/MM/YYYY')}
          </Fragment>
        ) : (
          <Fragment>
            <Fragment>
              {interviewRoundInfo?.date &&
                moment(interviewRoundInfo?.date[0]).format('DD/MM/YYYY')}
            </Fragment>
            &nbsp;-&nbsp;
            <Fragment>
              {interviewRoundInfo?.date &&
                moment(interviewRoundInfo?.date[1]).format('DD/MM/YYYY')}
            </Fragment>
          </Fragment>
        )}
      </Flex>
    ) : (
      '-'
    )
  }

  const getOtherDate = () => {
    return (
      <Fragment>
        <Fragment>
          {moment(interviewRoundInfo?.schedualedTime?.start).format(
            'DD/MM/YYYY'
          )}
        </Fragment>
        &nbsp;-&nbsp;
        <Fragment>
          {moment(interviewRoundInfo?.schedualedTime?.end).format('DD/MM/YYYY')}
        </Fragment>
      </Fragment>
    )
  }

  const getTime = () => {
    return (
      <Flex>
        {interviewRoundInfo?.time ? (
          <Fragment>
            <Fragment>
              {moment(interviewRoundInfo?.time, 'hh:mm:ss').format('hh:mm A')}
            </Fragment>
            &nbsp;-&nbsp;
            <Fragment>
              {moment(
                moment(interviewRoundInfo?.time, 'hh:mm:ss').add(
                  interviewRoundInfo?.duration,
                  'minutes'
                )
              ).format('hh:mm A')}
            </Fragment>
          </Fragment>
        ) : (
          '-'
        )}
      </Flex>
    )
  }

  const getOtherTime = () => {
    return (
      <Flex>
        <Fragment>
          <Fragment>
            {interviewRoundInfo?.schedualedTime &&
              moment(interviewRoundInfo?.schedualedTime?.start).format(
                'hh:mm A'
              )}
          </Fragment>
          &nbsp;-&nbsp;
          <Fragment>
            {interviewRoundInfo?.schedualedTime &&
              moment(interviewRoundInfo?.schedualedTime?.end).format('hh:mm A')}
          </Fragment>
        </Fragment>
      </Flex>
    )
  }
  return (
    <>
      <HeaderFlex centerVertically>
        <AntdAvatar
          size={30}
          IconName={interViewSchedulerData?.first_name?.charAt(0)}
        />
        <NameDiv>
          {interViewSchedulerData?.first_name}{' '}
          {interViewSchedulerData?.last_name}
        </NameDiv>
        <NameInfoDiv>Scheduled an interview</NameInfoDiv>
        <InterviewTime>
          <EllipseDot />
        </InterviewTime>
        <InterviewTime>
          {moment(interviewRoundInfo?.createdAt).format('hh:mm A')}
        </InterviewTime>
      </HeaderFlex>

      {candidateInfoData?.status === 'RESCHEDULE_REQUESTED' &&
      candidateInfoData?.stage === roundName ? (
        <InterviewInfo>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <DetailsDiv>Requested to Reschedule Interview</DetailsDiv>
            <div style={{ display: 'flex', gap: '20px' }}>
              <Button.Secondary
                text={'Reject Request'}
                height={'32px'}
                fontWeight={600}
                onClick={() => rejectData()}
              />
              <Button.Primary
                text={'Reschedule'}
                height={'32px'}
                onClick={() => onRejectButton()}
              />
            </div>
          </div>

          <RightFlex column>
            <LeftFlex>
              <DetailsNameDiv>Remarks</DetailsNameDiv>
              <ContentDiv>{reasonItem}</ContentDiv>
            </LeftFlex>
          </RightFlex>
        </InterviewInfo>
      ) : (
        <InterviewInfo>
          <DetailsDiv>Details</DetailsDiv>
          <RightFlex column>
            <LeftFlex>
              <DetailsNameDiv>Date.........</DetailsNameDiv>
              <ContentDiv>
                {interviewRoundInfo?.interview?.interviewType === 'ASSESMENT'
                  ? getDate()
                  : getOtherDate()}
              </ContentDiv>
            </LeftFlex>

            {!(
              interviewRoundInfo?.interview?.interviewType === 'ASSESMENT' &&
              interviewRoundInfo?.mode === 'EXTERNAL_LINK'
            ) && (
              <LeftFlex>
                <DetailsNameDiv>Time</DetailsNameDiv>
                <ContentDiv>
                  {interviewRoundInfo?.interview?.interviewType === 'ASSESMENT'
                    ? getTime()
                    : getOtherTime()}
                </ContentDiv>
              </LeftFlex>
            )}

            <LeftFlex>
              <DetailsNameDiv>Instructions</DetailsNameDiv>
              <ContentDiv style={{ whiteSpace: 'pre-wrap' }}>{interviewRoundInfo?.instructions}</ContentDiv>
            </LeftFlex>
          </RightFlex>
        </InterviewInfo>
      )}

      {!!interviewRoundInfo?.feedback?.length > 0 && (
        <Fragment>
          <HeaderFlex centerVertically>
            <AntdAvatar
              size={30}
              IconName={interViewUpdaterData?.first_name?.charAt(0)}
            />
            <NameDiv>
              {interViewUpdaterData?.first_name}{' '}
              {interViewUpdaterData?.last_name}
            </NameDiv>
            <NameInfoDiv>Updated the status</NameInfoDiv>
            <InterviewTime>
              <EllipseDot />
            </InterviewTime>
            <InterviewTime>
              {moment(interviewRoundInfo?.createdAt).format('hh:mm A')}
            </InterviewTime>
          </HeaderFlex>
          <InterviewInfo>
            <UploadFlex spaceBetween row>
              <InterviewFlex centerVertically>
                <InterviewerDiv>Interviewed by </InterviewerDiv>
                {!Array.isArray(interViewer) && 'NA'}
                {Array.isArray(interViewer) && (
                  <Fragment>
                    {interViewer?.length === 1 ? (
                      <Fragment>
                        <AntdAvatar
                          size={29}
                          IconName={interViewer[0]?.first_name?.charAt(0)}
                        />
                        <NameDiv>
                          {interViewer[0]?.first_name}{' '}
                          {interViewer[0]?.last_name}
                        </NameDiv>
                      </Fragment>
                    ) : (
                      <Fragment>
                        {interViewer?.slice(0, 5)?.map((data, kIndex) => (
                          <Padding key={data?.first_name + kIndex}>
                            <AntdAvatar
                              size={29}
                              IconName={data?.first_name?.charAt(0)}
                            />
                          </Padding>
                        ))}
                        {interViewer?.length > 5 && (
                          <AntdAvatar
                            size={29}
                            IconName={`+${interViewer?.length - 5}`}
                          />
                        )}
                      </Fragment>
                    )}
                  </Fragment>
                )}
              </InterviewFlex>
            </UploadFlex>
            <DetailsDiv>Remarks</DetailsDiv>
            <RightFlex>
              {interviewRoundInfo?.feedback?.map((item, index) => {
                return (
                  <LeftFlex
                    noBoader={
                      interviewRoundInfo?.feedback?.length - 1 !== index
                    }
                    key={index + 'remarks'}
                  >
                    <DetailsNameDiv>{item?.type} </DetailsNameDiv>
                    <ContentDiv>
                      {item?.value}{' '}
                      {interviewRoundInfo?.interview?.interviewType ===
                        'ASSESMENT' && '%'}
                    </ContentDiv>
                  </LeftFlex>
                )
              })}
            </RightFlex>
            {(candidateInfoData?.status === 'HOLD' ||
              candidateInfoData?.status === 'REJECTED') && (
              <CommonFlex column>
                <DetailsDiv>Remark </DetailsDiv>
                <RightFlex>
                  <CommentDiv>
                    {interviewRoundInfo?.remark
                      ? interviewRoundInfo?.remark
                      : '-'}
                  </CommentDiv>
                </RightFlex>
              </CommonFlex>
            )}
            <CommonFlex column>
              <DetailsDiv>Comment </DetailsDiv>
              <RightFlex>
                <CommentDiv>
                  {interviewRoundInfo?.comment
                    ? interviewRoundInfo?.comment
                    : '-'}
                </CommentDiv>
              </RightFlex>
            </CommonFlex>
            {}
            <Fragment>
              <CommonFlex column>
                <DetailsDiv>Strengths </DetailsDiv>
                <RightFlex>
                  <CommentDiv>
                    {interviewRoundInfo?.strength
                      ? interviewRoundInfo?.strength
                      : '-'}
                  </CommentDiv>
                </RightFlex>
              </CommonFlex>{' '}
              <CommonFlex column>
                <DetailsDiv>Weakness </DetailsDiv>
                <RightFlex>
                  <CommentDiv>
                    {interviewRoundInfo?.weakness
                      ? interviewRoundInfo?.weakness
                      : '-'}
                  </CommentDiv>
                </RightFlex>
              </CommonFlex>
            </Fragment>
            {}
          </InterviewInfo>
        </Fragment>
      )}

      <CreateSlots
        setCreateSlotDrawer={setCreateSlotDrawer}
        createSlotDrawer={createSlotDrawer}
        setSelectedRoundType={setSelectedRoundType}
        selectedRoundType={selectedRoundType}
        selectedRound={selectedRound}
        setSelectedRound={setSelectedRound}
        selectedCandidate={selectedCandidate}
        setSelectedCandidate={setSelectedCandidate}
        setCandidateInfoData={setCandidateInfoData}
        selectedCandidateId={selectedCandidateId}
        setSelectedCandidateId={setSelectedCandidateId}
        setSearchParams={setSearchParams}
        addCorporateBranch={addCorporateBranch}
        interViewerList={interViewerList}
        rolesMetrics={rolesMetrics}
        createInterview={createInterview}
        driveId={driveId}
        roleId={roleId}
        driveInterViewerList={driveInterViewerList}
        getDriveInterviewerList={getDriveInterviewerList}
        driveData={driveData}
        candidateInfoData={candidateInfoData}
        getCandidateList={getCandidateList}
        candidateDeatils={candidateDeatils}
        getRoleMetrics={getRoleMetrics}
        getInterViewLocation={getInterViewLocation}
        getListOfCountries={getListOfCountries}
        getListOfStates={getListOfStates}
        getListOfCities={getListOfCities}
        listOfCountries={listOfCountries}
        listOfStates={listOfStates}
        listOfCities={listOfCities}
        interViewData={interViewData}
        interviewRoundInfo={interviewRoundInfo}
        corporateLocationsList={corporateLocationsList}
        getCorporateLocationsList={getCorporateLocationsList}
        getGroupDiscussionList={getGroupDiscussionList}
        groupList={groupList}
        UpdateScheudle={UpdateScheudle}
        ids={ids}
        setNotification={setNotification}
        setCandidateInfo={setCandidateInfo}
        getDriveRoleCandidatesList={getDriveRoleCandidatesList}
      />
    </>
  )
}

export default CollapseText
